module.exports = __webpack_public_path__ + "img/zengxudong.2e69fe84.jpg";